import { combineEpics } from 'redux-observable';
import { fetchUnresolvedIssues, initialRequestEpic, releaseVersionRequestEpic } from './get.tsx';
import {
	initialRequestSuccessEpic,
	releaseVersionRequestFailureEpic,
	releaseVersionRequestSuccessEpic,
} from './handlers.tsx';

export default combineEpics(
	initialRequestEpic,
	fetchUnresolvedIssues,
	initialRequestSuccessEpic,
	releaseVersionRequestEpic,
	releaseVersionRequestFailureEpic,
	releaseVersionRequestSuccessEpic,
);
